import React, { useState } from 'react';
import './style.css';
import logo from '../../assets/images/sp-finance-logo-2.png';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Button, Checkbox, Form, Input, InputNumber, Modal, Space, Spin } from 'antd';
import { postData, getData } from '../../config/api-connect';
import Spinner from '../../components/spinner';

const formItemLayout = {
  labelCol: {
    span: 7,
  },
  wrapperCol: {
    span: 12,
  },
};

const errorModal = (message) => {
  Modal.error({
    title: message,
  });
};

export default function Login() {
  const [number, setNumber] = useState('');
  const [otp, setOTP] = useState('');
  const [validate, setValidate] = useState(false);
  const [loading, setLoading] = useState(false);

  const onFinish = (values) => {
    alert('Success:', values);
  };

  const onFinishFailed = (errorInfo) => {
    alert('Failed:', errorInfo);
  };

  const onNumberChange = (e) => {
    setNumber(e.target.value);
  };

  const onOTPChange = (e) => {
    setOTP(e.target.value);
  };

  const onChangeLoading = () => {
    setLoading(!loading);
  };

  const handleSubmitNumber = () => {
    postData('/auth/verify_mobile_start', { mobile_no: number, name: 'hds' })
      .then((response) => {
        setLoading(false);
        setValidate(response.authentication);
      })
      .catch((error) => {
        setLoading(false);
        errorModal(error.message);
      });
  };

  const handleLoginUser = () => {
    setLoading(true);
    postData('/auth/verify_mobile', { mobile_no: number, otp: otp })
      .then((response) => {
        localStorage.setItem('access_id', response.user.id);
        localStorage.setItem('user_role', response.user.role);
        localStorage.setItem('user_name', response.user.name);
        window.location.reload();
      })
      .catch((error) => {
        setLoading(false);
        errorModal(error.message);
      });
  };

  const verifyNumber = () => {
    setLoading(true);
    postData('/finance/check_finance_access/', { mobile_no: number })
      .then((response) => {
        if (response.success) {
          handleSubmitNumber();
        } else {
          setLoading(false);
          errorModal(response.message);
        }
      })
      .catch((error) => {
        setLoading(false);
        errorModal(error.message);
      });
  };

  return (
    <Spin spinning={loading} indicator={<Spinner />}>
      <div className="login-main-container">
        <div className="login-navbar-container col-md-12">
          <div className="login-header">
            <img src={logo} alt="Sporthood Finance" />
          </div>
          <Form
            name="basic"
            labelCol={{
              span: 8,
            }}
            wrapperCol={{
              span: 16,
            }}
            initialValues={{
              remember: true,
            }}
            autoComplete="off"
            className="login-form-margin"
          >
            <Form.Item
              label="Mobile No"
              name="mobile_no"
              rules={[
                {
                  required: true,
                  message: 'Please input your mobile number!',
                },
              ]}
            >
              <Input value={number} onChange={onNumberChange} allowClear />
            </Form.Item>

            {validate && (
              <>
                <span className="login-otp-helper">
                  {' '}
                  6 digit OTP ( One Time Password ) is sent to {number}{' '}
                </span>

                <Form.Item
                  label="OTP"
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter 6 digit otp!',
                    },
                  ]}
                >
                  <Input value={otp} onChange={onOTPChange} />
                </Form.Item>
              </>
            )}

            <Form.Item className="login-form-item-center">
              {!validate ? (
                <Button type="primary" htmlType="submit" onClick={() => verifyNumber()}>
                  {' '}
                  Get OTP{' '}
                </Button>
              ) : (
                <Button type="primary" htmlType="submit" onClick={() => handleLoginUser()}>
                  {' '}
                  Login{' '}
                </Button>
              )}
            </Form.Item>
          </Form>
        </div>
      </div>
    </Spin>
  );
}
